/** One shape for an agency worker's identity in capture (audit-J D11, J16).
 * The controlled writers accept a person only as `display_name`, so the agency label and the
 * organisation are folded into that field by this single encoder, and read back by the decoder.
 * Every capture form (standard, combined, mobile) uses it, so the register and exports can tell
 * an agency worker from any other person. Total length stays within the writer's 120 characters. */
export const AGENCY_LABEL = 'Agency worker';
export const AGENCY_SEPARATOR = ' · ';
export const AGENCY_NAME_MAX = 120;

export function encodeAgencyDisplayName(
  name: string | null | undefined,
  organisation?: string | null,
): string {
  const person = name?.trim() ?? '';
  if (!person) return '';
  const org = organisation?.trim();
  return [person, AGENCY_LABEL, ...(org ? [org] : [])].join(AGENCY_SEPARATOR);
}

export function decodeAgencyDisplayName(
  displayName: string | null | undefined,
): { name: string; organisation: string } | null {
  if (!displayName) return null;
  const parts = displayName.split(AGENCY_SEPARATOR);
  if (parts.length < 2 || parts[1] !== AGENCY_LABEL) return null;
  const name = parts[0]!.trim();
  if (!name) return null;
  return { name, organisation: parts.slice(2).join(AGENCY_SEPARATOR).trim() };
}
